__turbopack_context__.v({
  "className": "pretendard_fc72c9bc-module__6TCyNG__className",
});
